import { render, staticRenderFns } from "./PageButtons.vue?vue&type=template&id=a502092e"
import script from "./PageButtons.vue?vue&type=script&lang=js"
export * from "./PageButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../filemanager/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports